export default function CollapseRemoveIcon({ color = "currentColor" }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="13" cy="13.0002" r="11.6667" stroke={color} />
      <path
        d="M8.05029 8.05029L17.9498 17.9498"
        stroke={color}
        strokeLinejoin="round"
      />
      <path
        d="M8.05029 17.9497L17.9498 8.05021"
        stroke={color}
        strokeLinejoin="round"
      />
    </svg>
  );
}
